<script>
export let platform = "m";

let _URL_TYPE = 3;
let _URL_CONST = [
	{'api':"http://localhost/public/index.php/",'web':"http://localhost"},
	{'api':"http://api.jiefang.com/public/index.php/",'web':"http://api.jiefang.com"},
	{'api':"https://jiefangdata.shushizi.com:8876/",'web':"https://www.shushizi.com"},
	{'api':`${window.location.origin}/public/index.php/`,'web':`${window.location.origin}`}
];

let API_SERVER_URL = _URL_CONST[_URL_TYPE]['api'];
let WEB_SERVER_URL = _URL_CONST[_URL_TYPE]['web'];

if (typeof top._APP_CONFIG != "undefined") {
  platform = "app";
  API_SERVER_URL = _APP_CONFIG.api;
  WEB_SERVER_URL = _APP_CONFIG.web?_APP_CONFIG.web:WEB_SERVER_URL;
}

const serverUrl = API_SERVER_URL;

const serverPre = WEB_SERVER_URL;
const clientOrigin = WEB_SERVER_URL;

let amapWebServerKey = '';
if (typeof top._AMAP_WEB_SERVER_KEY != "undefined") {
  amapWebServerKey = top._AMAP_WEB_SERVER_KEY;
}

const industryCategory= [
	'批发和零售业',
	'住宿和餐饮业',
	'居民服务、修理和其他服务业',
	'教育',
	'卫生和社会工作',
	'文化、体育和娱乐业',
	'制造业',
	'建筑业',
	'信息传输、软件和信息技术服务业',
	'交通运输、仓储和邮政业',
	'金融业',
	'房地产业',
	'租赁和商务服务业',
	'电力、热力、燃气及水生产和供应业',
	'农、林、牧、渔业',
	'采矿业',
	'科学研究和技术服务业',
	'水利、环境和公共设施管理业',
	'公共管理、社会保障和社会组织',
	'国际组织'
];



const industryTypes= [
//{'text':'批发和零售业','children':
	[
	{'text':'批发业',
	'children':[
		{'text':'农、林、牧产品批发'},
		{'text':'食品、饮料及烟草制品批发'},
		{'text':'纺织、服装及家庭用品批发'},
		{'text':'文化、体育用品及器材批发'},
		{'text':'医药及医疗器材批发'},
		{'text':'矿产品、建材及化工产品批发'},
		{'text':'机械设备、五金产品及电子产品批发'},
		{'text':'贸易经纪与代理'},
		{'text':'其他批发业'}]
	},
	{'text':'零售业',
	'children':[
		{'text':'综合零售'},
		{'text':'食品、饮料及烟草制品专门零售'},
		{'text':'纺织、服装及日用品专门零售'},
		{'text':'文化、体育用品及器材专门零售'},
		{'text':'医药及医疗器材专门零售'},
		{'text':'汽车、摩托车、零配件和燃料及其他动力销售'},
		{'text':'家用电器及电子产品专门零售'},
		{'text':'五金、家具及室内装饰材料专门零售'},
		{'text':'货摊、无店铺及其他零售业'}]
	}],
//},{'text':'住宿和餐饮业','children':
	[
	{'text':'住宿业',
	'children':[
		{'text':'旅游饭店'},
		{'text':'一般旅馆'},
		{'text':'其他住宿业'}]
	},
	{'text':'餐饮业',
	'children':[
		{'text':'正餐服务'},
		{'text':'快餐服务'},
		{'text':'饮料及冷饮服务'},
		{'text':'其他餐饮业'}]
	}],
//},{'text':'居民服务、修理和其他服务业','children':
	[
	{'text':'居民服务业',
	'children':[
		{'text':'家庭服务'},
		{'text':'托儿所服务'},
		{'text':'洗染服务'},
		{'text':'理发及美容服务'},
		{'text':'洗浴服务'},
		{'text':'保健服务'},
		{'text':'婚姻服务'},
		{'text':'殡葬服务'},
		{'text':'其他居民服务业'}]
	},
	{'text':'机动车、电子产品和日用产品修理业',
	'children':[
		{'text':'汽车、摩托车修理与维护'},
		{'text':'计算机和办公设备维修'},
		{'text':'家用电器修理'},
		{'text':'其他日用产品修理业'}]
	},
	{'text':'其他服务业',
	'children':[
		{'text':'清洁服务'},
		{'text':'其他未列明服务业'}]
	}],
//},{'text':'教育','children':
	[
	{'text':'教育',
	'children':[
		{'text':'学前教育'},
		{'text':'初等教育'},
		{'text':'中等教育'},
		{'text':'高等教育'},
		{'text':'特殊教育'},
		{'text':'技能培训、教育辅助及其他教育'}]
	}],
//},{'text':'卫生和社会工作','children':
	[
	{'text':'卫生',
	'children':[
		{'text':'医院'},
		{'text':'社区医疗与卫生院'},
		{'text':'门诊部（所）'},
		{'text':'计划生育技术服务活动'},
		{'text':'妇幼保健院（所、站）'},
		{'text':'专科疾病防治院（所、站）'},
		{'text':'疾病预防控制中心'},
		{'text':'其他卫生活动'}]
	},
	{'text':'社会工作',
	'children':[
		{'text':'提供住宿社会工作'},
		{'text':'不提供住宿社会工作'}]
	}],
//},{'text':'文化、体育和娱乐业','children':
[
	{'text':'新闻和出版业',
	'children':[
		{'text':'新闻业'},
		{'text':'出版业'}]
	},
	{'text':'广播、电视、电影和影视录音制作业',
	'children':[
		{'text':'广播'},
		{'text':'电视'},
		{'text':'电影和影视节目制作'},
		{'text':'电影和影视节目发行'},
		{'text':'电影放映'},
		{'text':'录音制作'}]
	},
	{'text':'文化艺术业',
	'children':[
		{'text':'文艺创作与表演'},
		{'text':'艺术表演场馆'},
		{'text':'图书馆与档案馆'},
		{'text':'文物及非物质文化遗产保护'},
		{'text':'博物馆'},
		{'text':'烈士陵园、纪念馆'},
		{'text':'群众文化活动'},
		{'text':'其他文化艺术业'}]
	},
	{'text':'体育',
	'children':[
		{'text':'体育组织'},
		{'text':'体育场馆'},
		{'text':'休闲健身活动'},
		{'text':'其他体育'}]
	},
	{'text':'娱乐业',
	'children':[
		{'text':'室内娱乐活动'},
		{'text':'游乐园'},
		{'text':'彩票活动'},
		{'text':'文化、娱乐、体育经纪代理'},
		{'text':'其他娱乐业'}]
	}],
//},{'text':'制造业','children':
	[
	{'text':'农副食品加工业',
	'children':[
		{'text':'谷物磨制'},
		{'text':'饲料加工'},
		{'text':'植物油加工'},
		{'text':'制糖业'},
		{'text':'屠宰及肉类加工'},
		{'text':'水产品加工'},
		{'text':'蔬菜、水果和坚果加工'},
		{'text':'其他农副食品加工'}]
	},
	{'text':'食品制造业',
	'children':[
		{'text':'焙烤食品制造'},
		{'text':'糖果、巧克力及蜜饯制造'},
		{'text':'方便食品制造'},
		{'text':'乳制品制造'},
		{'text':'罐头食品制造'},
		{'text':'调味品、发酵制品制造'},
		{'text':'其他食品制造'}]
	},
	{'text':'酒、饮料和精制茶制造业',
	'children':[
		{'text':'酒的制造'},
		{'text':'饮料制造'},
		{'text':'精制茶加工'}]
	},
	{'text':'烟草制品业',
	'children':[
		{'text':'烟叶复烤'},
		{'text':'卷烟制造'},
		{'text':'其他烟草制品制造'}]
	},
	{'text':'纺织业',
	'children':[
		{'text':'棉纺织及印染精加工'},
		{'text':'毛纺织及染整精加工'},
		{'text':'麻纺织及染整精加工'},
		{'text':'丝绢纺织及印染精加工'},
		{'text':'化纤织造及印染精加工'},
		{'text':'针织或钩针编织物及其制品制造'},
		{'text':'家用纺织制成品制造'},
		{'text':'非家用纺织制成品制造'}]
	},
	{'text':'纺织服装、服饰业',
	'children':[
		{'text':'机织服装制造'},
		{'text':'针织或钩针编织服装制造'},
		{'text':'服饰制造'}]
	},
	{'text':'皮革、毛皮、羽毛及其制品和制鞋业',
	'children':[
		{'text':'皮革鞣制加工'},
		{'text':'皮革制品制造'},
		{'text':'毛皮鞣制及制品加工'},
		{'text':'羽毛(绒)加工及制品制造'},
		{'text':'制鞋业'}]
	},
	{'text':'木材加工和木、竹、藤、棕、草制品业',
	'children':[
		{'text':'木材加工'},
		{'text':'人造板制造'},
		{'text':'木制品制造'},
		{'text':'竹、藤、棕、草等制品制造'}]
	},
	{'text':'家具制造业',
	'children':[
		{'text':'木质家具制造'},
		{'text':'竹、藤家具制造'},
		{'text':'金属家具制造'},
		{'text':'塑料家具制造'},
		{'text':'其他家具制造'}]
	},
	{'text':'造纸和纸制品业',
	'children':[
		{'text':'纸浆制造'},
		{'text':'造纸'},
		{'text':'纸制品制造'}]
	},
	{'text':'印刷和记录媒介复制业',
	'children':[{'text':'印刷'},
		{'text':'装订及印刷相关服务'},
		{'text':'记录媒介复制'}]
	},
	{'text':'文教、工美、体育和娱乐用品制造业',
	'children':[
		{'text':'文教办公用品制造'},
		{'text':'乐器制造'},
		{'text':'工艺美术品制造'},
		{'text':'体育用品制造'},
		{'text':'玩具制造'},
		{'text':'游艺器材及娱乐用品制造'}]
	},
	{'text':'石油加工、炼焦和核燃料加工业',
	'children':[
		{'text':'精炼石油产品制造'},
		{'text':'炼焦'},
		{'text':'核燃料加工'}]
	},
	{'text':'化学原料和化学制品制造业',
	'children':[
		{'text':'基础化学原料制造'},
		{'text':'肥料制造'},
		{'text':'农药制造'},
		{'text':'涂料、油墨、颜料及类似产品制造'},
		{'text':'合成材料制造'},
		{'text':'专用化学产品制造'},
		{'text':'炸药、火工及焰火产品制造'},
		{'text':'日用化学产品制造'}]
	},
	{'text':'医药制造业',
	'children':[
		{'text':'化学药品原料药制造'},
		{'text':'化学药品制剂制造'},
		{'text':'中药饮片加工'},
		{'text':'中成药生产'},
		{'text':'兽用药品制造'},
		{'text':'生物药品制造'},
		{'text':'卫生材料及医药用品制造'}]
	},
	{'text':'化学纤维制造业',
	'children':[
		{'text':'纤维素纤维原料及纤维制造'},
		{'text':'合成纤维制造'}]
	},
	{'text':'橡胶和塑料制品业',
	'children':[
		{'text':'橡胶制品业'},
		{'text':'塑料制品业'}]
	},
	{'text':'非金属矿物制品业',
	'children':[
		{'text':'水泥、石灰和石膏制造'},
		{'text':'石膏、水泥制品及类似制品制造'},
		{'text':'砖瓦、石材等建筑材料制造'},
		{'text':'玻璃制造'},
		{'text':'玻璃制品制造'},
		{'text':'玻璃纤维和玻璃纤维增强塑料制品制造'},
		{'text':'陶瓷制品制造'},
		{'text':'耐火材料制品制造'},
		{'text':'石墨及其他非金属矿物制品制造'}]
	},
	{'text':'黑色金属冶炼和压延加工业',
	'children':[
		{'text':'炼铁'},
		{'text':'炼钢'},
		{'text':'黑色金属铸造'},
		{'text':'钢压延加工'},
		{'text':'铁合金冶炼'}]
	},
	{'text':'有色金属冶炼和压延加工业',
	'children':[
		{'text':'常用有色金属冶炼'},
		{'text':'贵金属冶炼'},
		{'text':'稀有稀土金属冶炼'},
		{'text':'有色金属合金制造'},
		{'text':'有色金属铸造'},
		{'text':'有色金属压延加工'}]
	},
	{'text':'金属制品业',
	'children':[
		{'text':'结构性金属制品制造'},
		{'text':'金属工具制造'},
		{'text':'集装箱及金属包装容器制造'},
		{'text':'金属丝绳及其制品制造'},
		{'text':'建筑、安全用金属制品制造'},
		{'text':'金属表面处理及热处理加工'},
		{'text':'搪瓷制品制造'},
		{'text':'金属制日用品制造'},
		{'text':'其他金属制品制造'}]
	},
	{'text':'通用设备制造业',
	'children':[
		{'text':'锅炉及原动设备制造'},
		{'text':'金属加工机械制造'},
		{'text':'物料搬运设备制造'},
		{'text':'泵、阀门、压缩机及类似机械制造'},
		{'text':'轴承、齿轮和传动部件制造'},
		{'text':'烘炉、风机、衡器、包装等设备制造'},
		{'text':'文化、办公用机械制造'},
		{'text':'通用零部件制造'},
		{'text':'其他通用设备制造业'}]
	},
	{'text':'专用设备制造业',
	'children':[
		{'text':'采矿、冶金、建筑专用设备制造'},
		{'text':'化工、木材、非金属加工专用设备制造'},
		{'text':'食品、饮料、烟草及饲料生产专用设备制造'},
		{'text':'印刷、制药、日化及日用品生产专用设备制造'},
		{'text':'纺织、服装和皮革加工专用设备制造'},
		{'text':'电子和电工机械专用设备制造'},
		{'text':'农、林、牧、渔专用机械制造'},
		{'text':'医疗仪器设备及器械制造'},
		{'text':'环保、社会公共服务及其他专用设备制造'}]
	},
	{'text':'汽车制造业',
	'children':[
		{'text':'汽车整车制造'},
		{'text':'改装汽车制造'},
		{'text':'低速载货汽车制造'},
		{'text':'电车制造'},
		{'text':'汽车车身、挂车制造'},
		{'text':'汽车零部件及配件制造'}]
	},
	{'text':'铁路、船舶、航空航天和其他运输设备制造业',
	'children':[
		{'text':'铁路运输设备制造'},
		{'text':'城市轨道交通设备制造'},
		{'text':'船舶及相关装置制造'},
		{'text':'航空、航天器及设备制造'},
		{'text':'摩托车制造'},
		{'text':'自行车制造'},
		{'text':'非公路休闲车及零配件制造'},
		{'text':'潜水救捞及其他未列明运输设备制造'}]
	},
	{'text':'电气机械和器材制造业',
	'children':[
		{'text':'电机制造'},
		{'text':'输配电及控制设备制造'},
		{'text':'电线、电缆、光缆及电工器材制造'},
		{'text':'电池制造'},
		{'text':'家用电力器具制造'},
		{'text':'非电力家用器具制造'},
		{'text':'照明器具制造'},
		{'text':'其他电气机械及器材制造'}]
	},
	{'text':'计算机、通信和其他电子设备制造业',
	'children':[
		{'text':'计算机制造'},
		{'text':'通信设备制造'},
		{'text':'广播电视设备制造'},
		{'text':'雷达及配套设备制造'},
		{'text':'视听设备制造'},
		{'text':'电子器件制造'},
		{'text':'电子元件制造'},
		{'text':'其他电子设备制造'}]
	},
	{'text':'仪器仪表制造业',
	'children':[
		{'text':'通用仪器仪表制造'},
		{'text':'专用仪器仪表制造'},
		{'text':'钟表与计时仪器制造'},
		{'text':'光学仪器及眼镜制造'},
		{'text':'其他仪器仪表制造业'}]
	},
	{'text':'其他制造业',
	'children':[
		{'text':'日用杂品制造'},
		{'text':'煤制品制造'},
		{'text':'核辐射加工'},
		{'text':'其他未列明制造业'}]
	},
	{'text':'废弃资源综合利用业',
	'children':[
		{'text':'金属废料和碎屑加工处理'},
		{'text':'非金属废料和碎屑加工处理'}]
	},
	{'text':'金属制品、机械和设备修理业',
	'children':[
		{'text':'金属制品修理'},
		{'text':'通用设备修理'},
		{'text':'专用设备修理'},
		{'text':'铁路、船舶、航空航天等运输设备修理'},
		{'text':'电气设备修理'},
		{'text':'仪器仪表修理'},
		{'text':'其他机械和设备修理业'}]
	}],
//},{'text':'建筑业','children':
	[
	{'text':'房屋建筑业',
	'children':[{'text':'房屋建筑业'}]
	},
	{'text':'土木工程建筑业',
	'children':[
		{'text':'铁路、道路、隧道和桥梁工程建筑'},
		{'text':'水利和内河港口工程建筑'},
		{'text':'海洋工程建筑'},
		{'text':'工矿工程建筑'},
		{'text':'架线和管道工程建筑'},
		{'text':'其他土木工程建筑'}]
	},
	{'text':'建筑安装业',
	'children':[
		{'text':'电气安装'},
		{'text':'管道和设备安装'},
		{'text':'其他建筑安装业'}]
	},
	{'text':'建筑装饰和其他建筑业',
	'children':[
		{'text':'建筑装饰业'},
		{'text':'工程准备活动'},
		{'text':'提供施工设备服务'},
		{'text':'其他未列明建筑业'}]
	}],
//},{'text':'信息传输、软件和信息技术服务业','children':
	[
	{'text':'电信、广播电视和卫星传输服务',
	'children':[
		{'text':'电信'},
		{'text':'广播电视传输服务'},
		{'text':'卫星传输服务'}]
	},
	{'text':'互联网和相关服务',
	'children':[
		{'text':'互联网接入及相关服务'},
		{'text':'互联网信息服务'},
		{'text':'其他互联网服务'}]
	},
	{'text':'软件和信息技术服务业',
	'children':[
		{'text':'软件开发'},
		{'text':'信息系统集成服务'},
		{'text':'信息技术咨询服务'},
		{'text':'数据处理和存储服务'},
		{'text':'集成电路设计'},
		{'text':'其他信息技术服务业'}]
	}],
//},{'text':'交通运输、仓储和邮政业','children':
	[
	{'text':'铁路运输业',
	'children':[
		{'text':'铁路旅客运输'},
		{'text':'铁路货物运输'},
		{'text':'铁路运输辅助活动'}]
	},
	{'text':'道路运输业',
	'children':[
		{'text':'城市公共交通运输'},
		{'text':'公路旅客运输'},
		{'text':'道路货物运输'},
		{'text':'道路运输辅助活动'}]
	},
	{'text':'水上运输业',
	'children':[
		{'text':'水上旅客运输'},
		{'text':'水上货物运输'},
		{'text':'水上运输辅助活动'}]
	},
	{'text':'航空运输业',
	'children':[
		{'text':'航空客货运输'},
		{'text':'通用航空服务'},
		{'text':'航空运输辅助活动'}]
	},
	{'text':'管道运输业',
	'children':[{'text':'管道运输业'}]
	},
	{'text':'装卸搬运和运输代理业',
	'children':[
		{'text':'装卸搬运'},
		{'text':'运输代理业'}]
	},
	{'text':'仓储业',
	'children':[
		{'text':'谷物、棉花等农产品仓储'},
		{'text':'其他仓储业'}]
	},
	{'text':'邮政业',
	'children':[
		{'text':'邮政基本服务'},
		{'text':'快递服务'}]
	}],
//},{'text':'金融业','children':
	[
	{'text':'货币金融服务',
	'children':[
		{'text':'中央银行服务'},
		{'text':'货币银行服务'},
		{'text':'非货币银行服务'},
		{'text':'银行监管服务'}]
	},
	{'text':'资本市场服务',
	'children':[
		{'text':'证券市场服务'},
		{'text':'期货市场服务'},
		{'text':'证券期货监管服务'},
		{'text':'资本投资服务'},
		{'text':'其他资本市场服务'}]
	},
	{'text':'保险业',
	'children':[
		{'text':'人身保险'},
		{'text':'财产保险'},
		{'text':'再保险'},
		{'text':'养老金'},
		{'text':'保险经纪与代理服务'},
		{'text':'保险监管服务'},
		{'text':'其他保险活动'}]
	},
	{'text':'其他金融业',
	'children':[
		{'text':'金融信托与管理服务'},
		{'text':'控股公司服务'},
		{'text':'非金融机构支付服务'},
		{'text':'金融信息服务'},
		{'text':'其他未列明金融业'}]
	}],
//},{'text':'房地产业','children':
	[
	{'text':'房地产业',
	'children':[
		{'text':'房地产开发经营'},
		{'text':'物业管理'},
		{'text':'房地产中介服务'},
		{'text':'自有房地产经营活动'},
		{'text':'其他房地产业'}]
	}],
//},{'text':'租赁和商务服务业','children':
	[
	{'text':'租赁业',
	'children':[
		{'text':'机械设备租赁'},
		{'text':'文化及日用品出租'}]
	},
	{'text':'商务服务业',
	'children':[
		{'text':'企业管理服务'},
		{'text':'法律服务'},
		{'text':'咨询与调查'},
		{'text':'广告业'},
		{'text':'知识产权服务'},
		{'text':'人力资源服务'},
		{'text':'旅行社及相关服务'},
		{'text':'安全保护服务'},
		{'text':'其他商务服务业'}]
	}],
//},{'text':'电力、热力、燃气及水生产和供应业','children':
	[
	{'text':'电力、热力生产和供应业',
	'children':[
		{'text':'电力生产'},
		{'text':'电力供应'},
		{'text':'热力生产和供应'}]
	},
	{'text':'燃气生产和供应业',
	'children':[{'text':'燃气生产和供应业'}]
	},
	{'text':'水的生产和供应业',
	'children':[
		{'text':'自来水生产和供应'},
		{'text':'污水处理及其再生利用'},
		{'text':'其他水的处理、利用与分配'}]
	}],
//},{'text':'农、林、牧、渔业','children':
	[
	{'text':'农业',
	'children':[
		{'text':'谷物种植'},
		{'text':'豆类、油料和薯类种植'},
		{'text':'棉、麻、糖、烟草种植'},
		{'text':'蔬菜、食用菌及园艺作物种植'},
		{'text':'水果种植'},
		{'text':'坚果、含油果、香料和饮料作物种植'},
		{'text':'中药材种植'},
		{'text':'其他农业'}]
	},
	{'text':'林业',
	'children':[
		{'text':'林木育种和育苗'},
		{'text':'造林和更新'},
		{'text':'森林经营和管护'},
		{'text':'木材和竹材采运'},
		{'text':'林产品采集'}]
	},
	{'text':'畜牧业',
	'children':[
		{'text':'牲畜饲养'},
		{'text':'家禽饲养'},
		{'text':'狩猎和捕捉动物'},
		{'text':'其他畜牧业'}]
	},
	{'text':'渔业',
	'children':[
		{'text':'水产养殖'},
		{'text':'水产捕捞'}]
	},
	{'text':'农、林、牧、渔服务业',
	'children':[
		{'text':'农业服务业'},
		{'text':'林业服务业'},
		{'text':'畜牧服务业'},
		{'text':'渔业服务业'}]
	}],
//},{'text':'采矿业','children':
	[
	{'text':'煤炭开采和洗选业',
	'children':[
		{'text':'烟煤和无烟煤开采洗选'},
		{'text':'褐煤开采洗选'},
		{'text':'其他煤炭采选'}]
	},
	{'text':'石油和天然气开采业',
	'children':[
		{'text':'石油开采'},
		{'text':'天然气开采'}]
	},
	{'text':'黑色金属矿采选业',
	'children':[
		{'text':'铁矿采选'},
		{'text':'锰矿、铬矿采选'},
		{'text':'其他黑色金属矿采选'}]
	},
	{'text':'有色金属矿采选业',
	'children':[
		{'text':'常用有色金属矿采选'},
		{'text':'贵金属矿采选'},
		{'text':'稀有稀土金属矿采选'}]
	},
	{'text':'非金属矿采选业',
	'children':[
		{'text':'土砂石开采'},
		{'text':'化学矿开采'},
		{'text':'采盐'},
		{'text':'石棉及其他非金属矿采选'}]
	},
	{'text':'开采辅助活动',
	'children':[
		{'text':'煤炭开采和洗选辅助活动'},
		{'text':'石油和天然气开采辅助活动'},
		{'text':'其他开采辅助活动'}]
	},
	{'text':'其他采矿业',
	'children':[{'text':'其他采矿业'}]
	}],
//},{'text':'科学研究和技术服务业','children':
	[
	{'text':'研究和试验发展',
	'children':[
		{'text':'自然科学研究和试验发展'},
		{'text':'工程和技术研究和试验发展'},
		{'text':'农业科学研究和试验发展'},
		{'text':'医学研究和试验发展'},
		{'text':'社会人文科学研究'}]
	},
	{'text':'专业技术服务业',
	'children':[
		{'text':'气象服务'},
		{'text':'地震服务'},
		{'text':'海洋服务'},
		{'text':'测绘服务'},
		{'text':'质检技术服务'},
		{'text':'环境与生态监测'},
		{'text':'地质勘查'},
		{'text':'工程技术'},
		{'text':'其他专业技术服务业'}]
	},
	{'text':'科技推广和应用服务业',
	'children':[
		{'text':'技术推广服务'},
		{'text':'科技中介服务'},
		{'text':'其他科技推广和应用服务业'}]
	}],
//},{'text':'水利、环境和公共设施管理业','children':
	[
	{'text':'水利管理业',
	'children':[
		{'text':'防洪除涝设施管理'},
		{'text':'水资源管理'},
		{'text':'天然水收集与分配'},
		{'text':'水文服务'},
		{'text':'其他水利管理业'}]
	},
	{'text':'生态保护和环境治理业',
	'children':[
		{'text':'生态保护'},
		{'text':'环境治理业'}]
	},
	{'text':'公共设施管理业',
	'children':[
		{'text':'市政设施管理'},
		{'text':'环境卫生管理'},
		{'text':'城乡市容管理'},
		{'text':'绿化管理'},
		{'text':'公园和游览景区管理'}]
	}],
//},{'text':'公共管理、社会保障和社会组织','children':
	[
	{'text':'中国共产党机关',
	'children':[{'text':'中国共产党机关'}]
	},
	{'text':'国家机构',
	'children':[{'text':'国家权力机构'},
		{'text':'国家行政机构'},
		{'text':'人民法院'},
		{'text':'人民检察院'},
		{'text':'其他国家机构'}]
	},
	{'text':'人民政协、民主党派',
	'children':[{'text':'人民政协'},
		{'text':'民主党派'}]
	},
	{'text':'社会保障',
	'children':[{'text':'社会保障'}]
	},
	{'text':'群众团体、社会团体和其他成员组织',
	'children':[{'text':'群众团体'},
		{'text':'社会团体'},
		{'text':'基金会'},
		{'text':'宗教组织'}]
	},
	{'text':'基层群众自治组织',
	'children':[
		{'text':'社区自治组织'},
		{'text':'村民自治组织'}]
	}],
//},{'text':'国际组织','children':
	[
	{'text':'国际组织',
	'children':[{'text':'国际组织'}]
	}]
//}

];

const homeUrl = '/News'
const newsNav = [
	{'key':'top', 'name' : '推荐'},
	//{'key':'guonei', 'name' : '国内'},
	{'key':'guoji', 'name' : '国际'},
	//{'key':'yule', 'name' : '娱乐'},
	//{'key':'tiyu', 'name' : '体育'},
	//{'key':'junshi', 'name' : '军事'},
	//{'key':'keji', 'name' : '科技'},
	{'key':'caijing', 'name' : '财经'},
	//{'key':'shishang', 'name' : '时尚'},
	//{'key':'youxi', 'name' : '游戏'},
	//{'key':'qiche', 'name' : '汽车'},
	//{'key':'jiankang', 'name' : '健康'}
];

export default {
	clientOrigin,
	serverPre,
	platform,
	serverUrl,
	amapWebServerKey,
	industryCategory,
	industryTypes,
	homeUrl,
	newsNav
};
</script>


// WEBPACK FOOTER //
// src/router/Conf.vue